var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"message_item"},[_c('div',{staticClass:"msg_date_wrp"},[_c('span',{staticClass:"msg_date_box"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }